// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"AlertToggle_Wrapper__O+ZVS"};